"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
var tslib_1 = require("tslib");
var MAX_RETRIES = 3;
var MAX_WAIT_TIME = 2000;
// Replace list with 'is-retry-allowed' library once upgraded to Node 16
var retryErrorList = new Set([
    'ENOTFOUND',
    'ENETUNREACH',
    'EOPENBREAKER',
    'UNABLE_TO_GET_ISSUER_CERT',
    'UNABLE_TO_GET_CRL',
    'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
    'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
    'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
    'CERT_SIGNATURE_FAILURE',
    'CRL_SIGNATURE_FAILURE',
    'CERT_NOT_YET_VALID',
    'CERT_HAS_EXPIRED',
    'CRL_NOT_YET_VALID',
    'CRL_HAS_EXPIRED',
    'ERROR_IN_CERT_NOT_BEFORE_FIELD',
    'ERROR_IN_CERT_NOT_AFTER_FIELD',
    'ERROR_IN_CRL_LAST_UPDATE_FIELD',
    'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
    'OUT_OF_MEM',
    'DEPTH_ZERO_SELF_SIGNED_CERT',
    'SELF_SIGNED_CERT_IN_CHAIN',
    'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
    'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
    'CERT_CHAIN_TOO_LONG',
    'CERT_REVOKED',
    'INVALID_CA',
    'PATH_LENGTH_EXCEEDED',
    'INVALID_PURPOSE',
    'CERT_UNTRUSTED',
    'CERT_REJECTED',
    'HOSTNAME_MISMATCH',
]);
var retry = function (func_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return tslib_1.__awaiter(void 0, tslib_1.__spreadArray([func_1], tslib_1.__read(args_1), false), void 0, function (func, numRetries) {
        var internalRetry;
        if (numRetries === void 0) { numRetries = MAX_RETRIES; }
        return tslib_1.__generator(this, function (_a) {
            if (!numRetries) {
                return [2 /*return*/, func()];
            }
            internalRetry = function (attempt) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var err_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, func()];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            err_1 = _a.sent();
                            if (attempt < numRetries && Boolean(err_1.code) && !retryErrorList.has(err_1.code)) {
                                return [2 /*return*/, delay(function () { return internalRetry(attempt + 1); }, delayTime(attempt))]; // eslint-disable-line no-magic-numbers
                            }
                            else {
                                return [2 /*return*/, Promise.reject(err_1)];
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            return [2 /*return*/, internalRetry(0)];
        });
    });
};
exports.retry = retry;
var delay = function (fn, ms) {
    return new Promise(function (resolve) {
        return setTimeout(function () {
            resolve(fn());
        }, ms);
    });
};
var delayTime = function (attempt) {
    return Math.min(Math.pow(2, attempt) * 100, MAX_WAIT_TIME) + Math.floor(Math.random() * 10) + 1; // eslint-disable-line no-magic-numbers
};
//# sourceMappingURL=retry.js.map